'use client';

import { $React } from '@legendapp/state/react-web';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { useTabState } from '@/components/tabs/TabProvider';
import { cn } from '@/lib/cn';

export interface TabPanelProps extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'id'> {
    tabId: string;
}
export function TabPanel({ className, children, tabId, ...props }: TabPanelProps) {
    const tabElId = `tab-${tabId}`;
    const panelElId = `tabpanel-${tabId}`;
    const tabState$ = useTabState();

    const getIsActive = () => {
        const activeTabElId = tabState$.activeTabId.get();
        return activeTabElId === tabElId;
    };
    return (
        <$React.div
            $aria-expanded={getIsActive}
            $aria-current={getIsActive}
            className={cn('tab-content border-none', className)}
            id={panelElId}
            role="tabpanel"
            aria-labelledby={tabElId}
            {...props}
        >
            {children}
        </$React.div>
    );
}
